import { getCsrfToken } from "./util";
import { debounce } from "lodash";

export const apiGet = async (url, { headers } = {}) => {
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      ...(headers ? headers.map((x) => ({ [x.key]: x.value })) : []),
    },
  });

  const respText = await response.text();
  const parsedResponse = respText && JSON.parse(respText);
  return {
    parsedResponse,
    statusCode: response.status,
    statusText: response.statusText,
  };
};

export const apiPost = async (url, { headers, body } = {}) => {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": getCsrfToken(),
      ...(headers ? headers.map((x) => ({ [x.key]: x.value })) : []),
    },
    ...(body && { body: JSON.stringify(body) }),
  });

  const respText = await response.text();
  const parsedResponse = respText && JSON.parse(respText);
  return {
    parsedResponse,
    statusCode: response.status,
    statusText: response.statusText,
  };
};

export const debouncedApiGet = debounce(async (url) => {
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  });

  const respText = await response.text();
  return JSON.parse(respText);
});
